export function setFocus(parent: HTMLElement, selector: string, highlight = true) {
  if (!parent) {
    console.warn("invalid parent element passed to focus manager", { parent, selector });
    return;
  }

  const element = parent.querySelector(selector);
  if (element && element instanceof HTMLElement) {
    element.scrollIntoView({
      block: "nearest",
      inline: "nearest"
    });
    if (highlight && element instanceof HTMLInputElement) {
      element.select();
    }
    element.focus();
  } else {
    console.warn("selector provided to the focus manager resolved to null or a non focusable element", { parent, selector, element });
  }
}

export function setElementFocus(element: HTMLElement, highlight = true) {
  if (!element) return;

  element.scrollIntoView();
  if (highlight && element instanceof HTMLInputElement) {
    element.select();
  } else {
    console.warn("selector provided to the focus manager resolved to null or a non focusable element", { element });
  }
  element.focus();
}
